export const EMPTY_DRIVER = {
  driverCode: "",
  driverName: "",
  displayName: "",
  dutyStartTime: "",
  dutyEndTime: "",
  plannedDepartTime: "",
  plannedReturnTime: "",
  deliveryStopTime: "",
  collectionStopTime: "",
  vehicleTypeDescription: "",
  vehicleTypeCode: "",
  sectionCode: "",
  sectionName: "",
  saturnLockdown: false,
  startAtSatellite: false,
  endAtSatellite: false,
};
export const EDITABLE_ROUTE_STATUSES = [1, 2, 7, 13];

export const DRIVER_TYPES = {
  ODF: "O",
  LINKED: "D",
};

export const EMPTY_ODF_DRIVER = {
  driverCode: "None",
  value: "None",
  label: "None",
};
